import classNames from 'classnames';
import React from 'react';

import type { IClientMicrocreditListItem } from '@src/@types/clienttypes';
import type { AffSub4 } from '@src/@types/microcredits';
import { AdvertisingButton } from '@src/components/AdvertisingButton';
import { AdvertisingLink } from '@src/components/AdvertisingLink/AdvertisingLink';
import { HAS_OFFER_SOURCE } from 'entities/Analytics';
import {
  fullDealCalculatorHasOffersData,
  TO_FULL_DEAL_BOTTOM_SHEET_BUTTON_DEFAULT_TEXT,
} from 'entities/FullDeal/config';
import { FULL_DEAL_WEB_TO_WEB_LINKS, FULL_DEAL_WEB_TO_WEB_SOURCE } from 'features/FullDeal/config';

import { buildHasOfferLinkForFullDeal } from '../../lib';

import styles from './FullDealCalculatorBottomSheetActions.module.scss';

interface Props {
  amount: number;
  term: number;
  hasOffer: boolean;
  toFullDealButtonText: string;

  offer: IClientMicrocreditListItem;
  position: number;

  isUserFromGoogleSearch: boolean;
}

export const FullDealCalculatorBottomSheetActions = ({
  amount,
  term,
  hasOffer: _hasOffer,
  toFullDealButtonText,
  offer,
  position,
  isUserFromGoogleSearch,
}: Props) => {
  const { organization, name, _id } = offer;

  const affSub4ForMfoButton: AffSub4 = {
    organizationName: organization.name,
    productName: name,
    organizationId: organization._id,
    productId: _id,
  };

  const sourceAffC = `${HAS_OFFER_SOURCE}|position${position}`;
  const _toFullDealButtonText = toFullDealButtonText || 'Подобрать займ в приложении';

  return (
    <>
      <AdvertisingButton
        advSub={offer.advertising.advSub}
        analytics={offer}
        affSub4={fullDealCalculatorHasOffersData.affSub4}
        source={FULL_DEAL_WEB_TO_WEB_SOURCE.FROM_MODAL_OFFER}
        className={classNames(styles.advertisingButton, { [styles.redButton]: !isUserFromGoogleSearch })}
        block
        color={isUserFromGoogleSearch ? 'blue' : 'red'}
        size={52}
        // @fix проверить параметр показа showAuth
        link={buildHasOfferLinkForFullDeal({
          link: FULL_DEAL_WEB_TO_WEB_LINKS.FROM_OFFER_MOBILE,
          offerId: offer.advertising.offerId,
          amount,
          term,
        })}
        visibleLabel={_toFullDealButtonText}
      />

      <AdvertisingLink
        advSub={offer.advertising.advSub}
        analytics={offer}
        affSub4={affSub4ForMfoButton}
        source={sourceAffC}
        block
        className={styles.advertisingLink}
        size={52}
        variant="secondary"
        visibleLabel={`Продолжить на сайте ${!offer?._features?.isSravniOffer ? offer.organization.name : ''}`}
      />
    </>
  );
};
